var render = function() {
  var _obj
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "click-outside",
          rawName: "v-click-outside",
          value: _vm.onClickOutside,
          expression: "onClickOutside"
        }
      ],
      ref: "host",
      class: _vm.hostClasses
    },
    [
      _c(
        "div",
        { class: _vm.$style.itemSelect, on: { click: _vm.toggleSelect } },
        [
          _c("div", { class: _vm.$style.configuratorImageWrapper }, [
            _c(
              "div",
              { class: _vm.$style.orderConfiguratorImage },
              [
                _c("v-img", {
                  class: _vm.$style.orderConfiguratorImageProduct,
                  attrs: { src: _vm.imagePath, "aspect-ratio": "1" }
                }),
                _vm._v(" "),
                _vm.selected
                  ? _c(
                      "div",
                      { class: _vm.$style.orderConfiguratorCheckmark },
                      [
                        _c("svg", {
                          directives: [{ name: "svg", rawName: "v-svg" }],
                          class: _vm.$style.orderCheckmark,
                          attrs: { symbol: "checkmark-icon" }
                        })
                      ]
                    )
                  : _vm._e()
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { class: _vm.$style.orderConfiguratorProperties }, [
            _vm.currentItem.vegan
              ? _c("div", [
                  _c("img", {
                    attrs: {
                      alt: "Vegan",
                      src: require("@/assets/img/vegan@2x.jpg")
                    }
                  })
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.currentItem.glutenFree
              ? _c("div", [
                  _c("img", {
                    attrs: {
                      alt: "Gluten Free",
                      src: require("@/assets/img/glutenfree@2x.jpg")
                    }
                  })
                ])
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("div", { class: _vm.$style.orderConfiguratorName }, [
            _vm._v(_vm._s(_vm.currentItem.name))
          ]),
          _vm._v(" "),
          _vm.shouldShowPrice
            ? _c("div", { class: _vm.$style.orderConfiguratorPrice }, [
                _vm._v(
                  "\n      (+" +
                    _vm._s(_vm._f("currency")(_vm.price)) +
                    ")\n    "
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { class: _vm.$style.optionSubtitle }, [
            _vm._v("\n      " + _vm._s(_vm.currentItem.subTitle) + "\n    ")
          ])
        ]
      ),
      _vm._v(" "),
      _vm.isShowModifiers && _vm.selected
        ? _c("button", {
            class: _vm.$style.moreInfoBtn,
            on: { click: _vm.showOptions }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showQuantityPicker || _vm.isMobilePlatform
        ? _c("QuantityPicker", {
            class: [
              _vm.$style.quantityPicker,
              ((_obj = {}),
              (_obj[_vm.$style.visible] = _vm.showQuantityPicker),
              _obj)
            ],
            attrs: {
              quantity: _vm.quantity,
              maximum: _vm.currentItem.maxCount
            },
            on: {
              increaseQuantity: function($event) {
                return _vm.changeQuantity(1)
              },
              decreaseQuantity: function($event) {
                return _vm.changeQuantity(-1)
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.isShowModifiers
        ? _c(
            "div",
            { attrs: { id: _vm.optionId } },
            [
              _vm.itemOptions
                ? _c("AdditionalOption", {
                    class: _vm.$style.additionalOptions,
                    attrs: {
                      "item-key": _vm.itemKey,
                      "checked-modifier-key": _vm.checkedModifierKey
                    },
                    on: { input: _vm.setModifier }
                  })
                : _vm._e()
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/apps/configurator/components/ConfiguratorOption.vue?vue&type=template&id=0679685d&
// module id = null
// module chunks = 